module.exports = __webpack_public_path__ + "img/c00_buildingtechhuntingdogs_Normal_ua.1fa4ea88.webp";